import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=0dc8c670&scoped=true&"
import script from "./contract.ts?vue&type=script&lang=ts&"
export * from "./contract.ts?vue&type=script&lang=ts&"
import style0 from "./contract.scss?vue&type=style&index=0&id=0dc8c670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8c670",
  null
  
)

export default component.exports